import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export const passwordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const reg= /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,191}$/; // TODO: set to 12 again, after users migrated
  return !reg.test(control.value) ? {password: true} : null;
};